<template>
  <label
    :for="$props.id"
    class="btn  btn-fileReader m-0"
    :class="btnType ? btnType : 'btn-success'"
  >
    <input
      v-bind:style="fileReader"
      :id="$props.id"
      type="file"
      @change="loadTextFromFile"
      v-bind:accept="accept"
      ref="fileReader"
    />
    <div>
      <font-awesome-icon
        v-if="icon"
        icon="upload"
        style="cursor: pointer"
        v-b-modal.modal-deleteLeave
      />
      {{ this.fileName }}
    </div>
  </label>
</template>

<script>
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import SweetAlertService from "@/service/SweetAlertService";
export default {
  props: {
    accept: String,
    onlyText: Boolean,
    buttonText: String,
    btnType: String,
    id: {
      type: String,
      default: "fileReader"
    }
  },
  data() {
    return {
      fileReader: {
        display: "none"
      },
      dict: {},
      dictEnum: dictEnum,
      fileName: "",
      t: t,
      icon: true
    };
  },
  mounted() {
    this.fileName = this.buttonText
      ? this.buttonText
      : this.t.t(dictEnum.LBL_Import);
    this.icon = !this.onlyText;
  },

  methods: {
    getMsg(key) {
      return $msg.getValue(this.dict, key);
    },
    hasSuffix(str, suffixes) {
      const extension = str.substring(str.lastIndexOf(".") + 1);
      return suffixes.includes(extension.toLowerCase());
    },
    loadTextFromFile(ev) {
      console.log("loadTextFromFile---", ev);
      const file = ev.target.files[0];
      if (file) {
        let extensions = this.$props.accept.split(",");
        extensions = extensions.map(x => x.replace(".", "").toLowerCase());
        const isValidFileType = this.isValidFileType(file.name, extensions);
        console.log("extensions", extensions);
        console.log("isValidFileType: ", file.name, isValidFileType);
        if (isValidFileType) {
          const reader = new FileReader();
          reader.onload = e => {
            this.$data.fileName = file.name;
            console.log("load: ", this.hasSuffix(file.name, ["txt"]));
            console.log(
              "loadExcel: ",
              this.hasSuffix(file.name, ["xlsx", "xls"])
            );
            if (this.hasSuffix(file.name, ["txt"])) {
              this.$emit("load", e.target.result);
            } else if (this.hasSuffix(file.name, ["xlsx", "xls"])) {
              this.$emit("loadExcel", e.target.result);
            }
          };
          reader.readAsText(file);
        } else {
          this.reset();
          SweetAlertService.error("Error", "File type not supported");
        }
      }
    },

    isValidFileType(fName, extensions) {
      return (
        extensions.indexOf(
          fName
            .split(".")
            .pop()
            .toLowerCase()
        ) > -1
      );
    },
    reset() {
      this.$refs.fileReader.value = "";
      this.$data.fileName = t.t(dictEnum.BTN_ChooseFile);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/FileReader.vue